const ACTIVE_CALL_STORAGE_KEY = 'reprev:active-call';

export function setActiveCallSession(active: boolean): void {
  if (typeof window === 'undefined') return;
  if (active) {
    sessionStorage.setItem(ACTIVE_CALL_STORAGE_KEY, 'true');
  } else {
    sessionStorage.removeItem(ACTIVE_CALL_STORAGE_KEY);
  }
}

export function hasActiveCallSession(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(ACTIVE_CALL_STORAGE_KEY) === 'true';
}
